import { useState } from 'react';
import { useToasts } from '@scope/scope-one-ui/core/Messages/context';
import {getBookmark, setBookmark} from "../../../store/localStorage";

export const useMenuBookmarks = () => {
  const [bookmarkedHomepage, setBookmarkedHomepage] = useState(getBookmark() ?? '');
  const { success } = useToasts();

  const bookmarkNewHomepage = (url: string, title: string) => {
    const homeAddress = url === bookmarkedHomepage ? '' : url;
    setBookmarkedHomepage(homeAddress);
    setBookmark(homeAddress);
    success({
      title: 'Success!',
      content: `You have changed your homepage to ${homeAddress ? title : 'PageOne'}`,
    });
  };

  return {
    bookmarkedHomepage,
    bookmarkNewHomepage,
  };
};
